import * as services from "@api";
import { requiredValidate } from "../utils";

/**
 * operationLog
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  operCode: string
 * }
 * @returns
 */
export async function operationLog(rootStore: any, options: any = {}) {
  requiredValidate.call(this, options, ['operCode']);
  const { pageStore = {} } = rootStore;
  const { query = {} } = pageStore;
  const { serviceCode } = query;
  if (serviceCode) {
    await services?.transferCommonRest?.({
      params: {
        ...query,
        busiObj: options.busiObj || query.busiObj,
      },
      data: {
        method: 'POST',
        targetServiceKey: 'iuap-apcom-auditlog',
        url: '/log-pub/rest/operation/save',
        parameter: {
          device: query?.terminalType ?? 1,
          serviceCode,
          ...options
        }
      }
    });
  }
}